var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#002E45"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1421_3602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57422 26.2816C9.57422 24.3123 10.3565 22.4236 11.749 21.0311C13.1415 19.6386 15.0302 18.8563 16.9995 18.8563C18.9688 18.8563 20.8575 19.6386 22.25 21.0311C23.6425 22.4236 24.4248 24.3123 24.4248 26.2816H9.57422ZM16.9995 17.9282C13.9227 17.9282 11.4305 15.436 11.4305 12.3592C11.4305 9.28233 13.9227 6.79022 16.9995 6.79022C20.0764 6.79022 22.5685 9.28233 22.5685 12.3592C22.5685 15.436 20.0764 17.9282 16.9995 17.9282Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1421_3602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2759,
    height: 22.2759,
    fill: "white",
    transform: "translate(5.86133 5.86206)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/User2.adf78293.svg";
export { ForwardRef as ReactComponent };